module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/comicbook-f034ecf3bf36b5a2b91f5008babdffe0.png";